import DropDownFilterCell from "../../../components/GridCell/GridDropDownFilterCell";
import GridDateFormatCell from "../../../components/GridCell/GridDateFormatCell";
import { t } from "i18next";

const statusCell = (field) => (props) => {
  const value = props.dataItem[field];
  return <td>{t(value?.toLowerCase?.() || value || "-")}</td>;
};

export const guestParticipantGridColumns = [
  {
    field: "ad",
    title_key: "name",
    width: "140px",
    filterable: true,
  },
  {
    field: "soyad",
    title_key: "surname",
    width: "140px",
    filterable: true,
  },
  {
    field: "telefon",
    title_key: "phone",
    width: "150px",
    filterable: true,
  },
  {
    field: "email",
    title_key: "email",
    width: "200px",
    filterable: true,
  },
  {
    field: "toplaM_DAVETLI_SAYISI",
    title_key: "total_guest_count",
    width: "150px",
    filterable: true,
  },
  {
    field: "qR_HAKKI_DOLDU",
    title_key: "qr_quota_full",
    width: "140px",
    filterable: true,
    filterCell: (props) => (
      <DropDownFilterCell
        data={[
          { value: "EVET", text: t("yes") },
          { value: "HAYIR", text: t("no") },
        ]}
        {...props}
      />
    ),
    cell: statusCell("qR_HAKKI_DOLDU"),
  },
  {
    field: "qR_OKUTMA_SAYISI",
    title_key: "qr_scan_usage",
    width: "140px",
    filterable: false,
    cell: (props) => {
      const used = props.dataItem.qR_OKUTMA_SAYISI ?? 0;
      const max = Math.max(1, props.dataItem.toplaM_DAVETLI_SAYISI ?? 1);
      return (
        <td>
          {used}/{max}
        </td>
      );
    },
  },
  {
    field: "qR_OKUTMA_TARIHI",
    title_key: "qr_scan_date",
    width: "180px",
    cell: (props) =>
      props.dataItem.qR_OKUTMA_TARIHI
        ? GridDateFormatCell(props, t("date_formats.shortDateTime"))
        : (
            <td>-</td>
          ),
    filterable: false,
  },
  {
    field: "smS_GONDERILDI",
    title_key: "sms_status",
    width: "140px",
    filterable: true,
    filterCell: (props) => (
      <DropDownFilterCell
        data={[
          { value: "EVET", text: t("yes") },
          { value: "HAYIR", text: t("no") },
          { value: "GONDERILEMEDI", text: t("gonderilemedi") },
        ]}
        {...props}
      />
    ),
    cell: statusCell("smS_GONDERILDI"),
  },
  {
    field: "maiL_GONDERILDI",
    title_key: "mail_status",
    width: "140px",
    filterable: true,
    filterCell: (props) => (
      <DropDownFilterCell
        data={[
          { value: "EVET", text: t("yes") },
          { value: "HAYIR", text: t("no") },
          { value: "GONDERILEMEDI", text: t("gonderilemedi") },
        ]}
        {...props}
      />
    ),
    cell: statusCell("maiL_GONDERILDI"),
  },
];
